import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import DataTable from "../../components/data-table";
import { fetchDstRegions } from "../../actions/dst-regions";
import { dstRegionsPath } from "../../routes";
import { MONTH_NAMES } from "../../constants/month-names";
import { WEEKDAY_NAMES } from "../../constants/weekday-names";
import { WEEKDAY_ORDINALS } from "../../constants/weekday-ordinal";

const COLUMNS = [
  { id: "id", label: "ID", link: true },
  { id: "display_name", label: "Name" },
  { id: "start.month", label: "Start Month" },
  { id: "start.weekday", label: "Start Weekday" },
  { id: "start.weekday_ordinal", label: "Start Weekday Ordinal" },
  { id: "end.month", label: "End Month" },
  { id: "end.weekday", label: "End Weekday" },
  { id: "end.weekday_ordinal", label: "End Weekday Ordinal" },
];

const parseTransitionRule = (rule) => {
  const month = MONTH_NAMES[rule.month];
  const weekday = WEEKDAY_NAMES[rule.weekday];
  const weekday_ordinal = WEEKDAY_ORDINALS.find(
    (item) => item.value === rule.weekday_ordinal,
  ).description;

  return { ...rule, month, weekday, weekday_ordinal };
};

const parseDstRegion = (region) => {
  const parsedStart = parseTransitionRule(region.start);
  const parsedEnd = parseTransitionRule(region.end);

  const parsedRegion = { ...region, start: parsedStart, end: parsedEnd };

  return parsedRegion;
};

const DstRegions = (props) => {
  const { getDstRegions, dstRegions } = props;
  const [parsedRegionsData, setParsedRegionsData] = useState([]);

  useEffect(
    () => {
      if (dstRegions.length) {
        setParsedRegionsData(dstRegions.map(parseDstRegion));
      }
    },
    [dstRegions],
  );

  return (
    <div className="animated fadeIn">
      <Row>
        <Col xl={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col lg={4}>DST Regions</Col>
                <Col lg={8} style={{ textAlign: "right" }}>
                  <Button
                    href={`/#/${dstRegionsPath}/new`}
                    color="success"
                    size="sm"
                  >
                    New
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <DataTable
                resource="parsedRegionsData"
                dataSource={getDstRegions}
                columns={COLUMNS}
                urlSchema={`${dstRegionsPath}`}
                {...props}
                parsedRegionsData={parsedRegionsData}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

DstRegions.propTypes = {
  getDstRegions: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  dstRegions: PropTypes.arrayOf(PropTypes.object),
};

DstRegions.defaultProps = {
  dstRegions: [],
};

const mapStateToProps = ({ dstRegions }) => ({
  loading: dstRegions.loading,
  dstRegions: dstRegions.items,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDstRegions: (sort) => fetchDstRegions(sort),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DstRegions);
